<app-entity-mat-dialog-title
    title="Student Contact"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': !formDataLoaded
     }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered"
            *ngIf="!formDataLoaded" mode="indeterminate">
        </mat-progress-spinner>

        <mat-tab-group [(selectedIndex)]="this.selectedIndex"
            (selectedTabChange)="setFormMode($event.index)"
            animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">
                <app-entity-mat-tab-view
                    [entityData]="entityData"></app-entity-mat-tab-view>
            </mat-tab>

            <mat-tab
                label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <app-error-message
                    [message]=this.errorMessage></app-error-message>

                <!-- Form -->
                <form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">

                    <div class="container">

                        <div class="row">

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>First Name</mat-label>
                                    <input
                                        name="field_first_name"
                                        required
                                        matInput
                                        ngModel>
                                </mat-form-field>
                            </div>

                            <div class="col-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Last Name</mat-label>
                                    <input
                                        name="field_last_name"
                                        required
                                        matInput
                                        ngModel>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Email Address</mat-label>
                                    <input required ngModel
                                        name="field_email" matInput>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Birthday</mat-label>
                                    <input matInput
                                        [owlDateTime]="birthdayPicker"
                                        ngModel
                                        #birthdayModel="ngModel"
                                        name="field_birthday"
                                        [max]="todaysDate"
                                        [placeholder]="birthdayFormat"
                                        (blur)="normalizeBirthday(birthdayModel)">
                                    <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="birthdayPicker">
                                        <mat-icon>calendar_today</mat-icon>
                                    </span>
                                    <owl-date-time #birthdayPicker [pickerType]="'calendar'" [startView]="'multi-years'"></owl-date-time>
                                    <mat-error *ngIf="birthdayModel.errors?.['owlDateTimeParse']">Enter the date as {{ birthdayFormat }}</mat-error>
                                    <mat-error *ngIf="birthdayModel.errors?.['owlDateTimeMax']">Birthday can't be in the future</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6" *ngIf="showFiscalCode">
                                <mat-form-field class="full-width-field">
                                    <mat-label>{{ 'PAYMENTS.FISCAL_CODE' | translate }}</mat-label>
                                    <input ngModel name="field_fiscal_code" maxlength="16" matInput>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Preferred Communication Method</mat-label>
                                    <mat-select ngModel name="field_notification_preference">
                                        <mat-option *ngFor="let preference of this._fieldsService.communicationPreferences" [value]="preference.value">
                                            {{preference.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6 phone-field-wrapper">
                                <label class="phone-label">Home Phone</label>
                                <ngx-intl-tel-input
                                    [cssClass]="'form-control'"
                                    [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                    [enableAutoCountrySelect]="false"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryPlaceholder]="'Search Country'"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="phoneCountry?.toLowerCase()"
                                    [phoneValidation]="false"
                                    [separateDialCode]="true"
                                    (countryChange)="onPhoneCountryChange($event)"
                                    name="field_home_phone"
                                    ngModel>
                                </ngx-intl-tel-input>
                            </div>

                            <div class="col-md-6 phone-field-wrapper">
                                <label class="phone-label">Cell Phone</label>
                                <ngx-intl-tel-input
                                    [cssClass]="'form-control'"
                                    [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
                                    [enableAutoCountrySelect]="false"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryPlaceholder]="'Search Country'"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="phoneCountry?.toLowerCase()"
                                    [phoneValidation]="false"
                                    [separateDialCode]="true"
                                    (countryChange)="onPhoneCountryChange($event)"
                                    name="field_cell_phone"
                                    ngModel>
                                </ngx-intl-tel-input>
                            </div>

                            <div class="col-md-6 d-none">
                                <div class="mt-2">
                                    <mat-label class="d-block mb-2">Gender</mat-label>
                                    <mat-radio-group name="field_gender" ngModel
                                        aria-label="Gender">
                                        <mat-radio-button value="1" class="me-3">Male</mat-radio-button>
                                        <mat-radio-button value="0">Female</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="mt-2">
                                    <mat-label class="d-block mb-2">Lead/Follow</mat-label>
                                    <mat-radio-group name="field_lead_follow" ngModel
                                        aria-label="Lead/Follow">
                                        <mat-radio-button value="lead" class="me-3">Lead</mat-radio-button>
                                        <mat-radio-button value="follow">Follow</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>

                            <!-- <div class="col-md-6">
                                <div class="mt-2">
                                    <mat-label class="d-block mb-2">Attending Lessons</mat-label>
                                    <mat-radio-group
                                        name="field_attending_lessons" ngModel
                                        aria-label="Attending Lessons">
                                        <mat-radio-button value="solo" class="me-3">Solo</mat-radio-button>
                                        <mat-radio-button value="partner">With Partner</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div> -->

                            <div class="col-12 mt-3">
                                <mat-checkbox ngModel
                                    name="field_communication_opt_in">
                                    Communication Consent Opt-in
                                </mat-checkbox>
                            </div>

                            <div class="col-6 mt-3">
                                <mat-checkbox [(ngModel)]="isArchived"
                                    name="field_archived">
                                    Archived
                                </mat-checkbox>
                            </div>

                            <div class="col-6 mt-3" *ngIf="isArchived">
                                <mat-form-field class="full-width-field">
                                    <mat-label>Archive Reason</mat-label>
                                    <mat-select ngModel name="field_archive_reason">
                                        <mat-option value="">-- Select Reason --</mat-option>
                                        <mat-option *ngFor="let reason of this._fieldsService.archiveReasons" [value]="reason.value">
                                            {{reason.label}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="row">


                                <!-- Address  -->
                                <div class="mt-3" ngModelGroup="field_address">
                                    <input
                                        class="d-none"
                                        name="multiple_properties"
                                        matInput
                                        ngModel="true">
                                    <mat-expansion-panel class="mt-1"
                                        expanded="false">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                Address
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                Optional
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div class="row">
                                            <div class="col-12">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>Street
                                                        Address</mat-label>
                                                    <input ngModel
                                                        name="address_line1"
                                                        matInput>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-5">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>City</mat-label>
                                                    <input ngModel
                                                        name="locality"
                                                        matInput>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-5">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>{{ administrativeAreaLabel }}</mat-label>
                                                    <mat-select matInput ngModel
                                                        name="administrative_area"
                                                        *ngIf="internationalAddressService?.hasAdministrativeAreas(selectedCountry)">
                                                        <mat-option>None</mat-option>
                                                        <mat-option
                                                            *ngFor="let area of internationalAddressService.getAdministrativeAreas(selectedCountry)"
                                                            [value]="area.abbreviation">
                                                            {{ area.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <input matInput ngModel name="administrative_area"
                                                        *ngIf="!internationalAddressService?.hasAdministrativeAreas(selectedCountry)">
                                                </mat-form-field>
                                            </div>

                                            <div class="col-2">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>{{ postalCodeLabel }}</mat-label>
                                                    <input ngModel
                                                        name="postal_code"
                                                        matInput>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-12">
                                                <mat-form-field
                                                    class="full-width-field">
                                                    <mat-label>Country</mat-label>
                                                    <mat-select [(ngModel)]="selectedCountry"
                                                        name="country_code"
                                                        (ngModelChange)="onCountryChange($event)">
                                                        <mat-option *ngFor="let country of this._fieldsService.countries"
                                                            [value]="country.abbreviation">
                                                            {{ country.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                </div>

                            </div>
                        </div>

                    </div>
                </form>
            </mat-tab>

            <mat-tab label="Delete" [disabled]="this.initActionType == 'create'"
                *ngIf="this.actionType != 'create'">
                <app-entity-confirm-delete></app-entity-confirm-delete>
            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<mat-dialog-actions align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <button type="button" (click)="onSubmit(f);" mat-raised-button
            color="primary">Save</button>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button" (click)="setFormMode('delete')"
                mat-raised-button color="accent">Delete</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button
                color="primary"
                [disabled]="!formDataLoaded">Save</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType == 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button
                color="accent">Cancel</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button
                color="primary"
                [disabled]="!formDataLoaded">Save</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="setFormMode('edit')" type="submit" mat-raised-button
            color="accent">Cancel</button>
        <!-- <button (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])" type="submit" mat-raised-button
            color="accent">Delete</button> -->
    </ng-container>
</mat-dialog-actions>
